export const stringMapDefault = {
    ariaLiveActiveColor: "Current hex color selected is",
    applyButton: "OK",
    cancelButton: "Cancel",
    colorPaletteBackground: "Core Colors",
    colorPaletteText: "Text",
    colorPaletteCustom: "Custom",
    confirmButton: "OK",
    inputLabel: "Selected Color",
    inputVariantButton: "Switch Color Input",
    opacitySelectTooltip: "Opacity"
};
